import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImageFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30 9H10C9.73478 9 9.48043 9.10536 9.29289 9.29289C9.10536 9.48043 9 9.73478 9 10V30C9 30.2652 9.10536 30.5196 9.29289 30.7071C9.48043 30.8946 9.73478 31 10 31H30C30.2652 31 30.5196 30.8946 30.7071 30.7071C30.8946 30.5196 31 30.2652 31 30V10C31 9.73478 30.8946 9.48043 30.7071 9.29289C30.5196 9.10536 30.2652 9 30 9ZM17.5 14C17.7967 14 18.0867 14.088 18.3334 14.2528C18.58 14.4176 18.7723 14.6519 18.8858 14.926C18.9994 15.2001 19.0291 15.5017 18.9712 15.7926C18.9133 16.0836 18.7704 16.3509 18.5607 16.5607C18.3509 16.7704 18.0836 16.9133 17.7926 16.9712C17.5017 17.0291 17.2001 16.9994 16.926 16.8858C16.6519 16.7723 16.4176 16.58 16.2528 16.3334C16.088 16.0867 16 15.7967 16 15.5C16 15.1022 16.158 14.7206 16.4393 14.4393C16.7206 14.158 17.1022 14 17.5 14ZM13 25L16 20L19 23L23 17L27 25H13Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgImageFilled);
export default ForwardRef;
